import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { taskApi } from '../api';
import { Spinner, EmptyState, StatusBadge } from '../components/ui';

export default function CriticalTasks() {
  const navigate          = useNavigate();
  const [tasks,  setTasks]  = useState([]);
  const [loading,setLoading]= useState(true);

  useEffect(() => {
    taskApi.getCritical()
      .then(r => setTasks(r.data.data || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const sorted = [...tasks].sort((a, b) => {
    if (a.status === 'OVERDUE' && b.status !== 'OVERDUE') return -1;
    if (b.status === 'OVERDUE' && a.status !== 'OVERDUE') return  1;
    return new Date(a.deadline) - new Date(b.deadline);
  });

  return (
    <div style={{ padding: '24px', maxWidth: '800px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
        <span style={{ fontSize: '28px' }}>🚨</span>
        <div>
          <h1 style={S.title}>Critical Tasks</h1>
          <p style={S.sub}>{tasks.length} critical task{tasks.length !== 1 ? 's' : ''} not yet done</p>
        </div>
      </div>

      <div style={{ padding: '12px 16px', background: '#FFF5F5', border: '1px solid #FEB2B2', borderRadius: 'var(--radius-md)', marginBottom: '16px', fontSize: '13px', color: 'var(--color-danger)' }}>
        All tasks marked CRITICAL that are not yet completed. Sorted by urgency.
      </div>

      {loading ? (
        <div style={{ display: 'flex', justifyContent: 'center', padding: '40px' }}><Spinner /></div>
      ) : sorted.length === 0 ? (
        <EmptyState icon="✓" title="No critical tasks" subtitle="No tasks are marked Critical and pending completion." />
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          {sorted.map(task => (
            <div key={task.id} onClick={() => navigate(`/tasks/${task.id}`)} style={{
              background: 'var(--color-surface)', borderRadius: 'var(--radius-md)',
              border: '1px solid #FEB2B2', padding: '14px 16px', cursor: 'pointer',
              borderLeft: `4px solid #C53030`,
              transition: 'box-shadow 0.15s',
            }}
              onMouseEnter={e => e.currentTarget.style.boxShadow = 'var(--shadow-md)'}
              onMouseLeave={e => e.currentTarget.style.boxShadow = 'none'}
            >
              <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '12px' }}>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <p style={{ fontWeight: 600, fontSize: '15px', marginBottom: '6px' }}>{task.title}</p>
                  <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'center' }}>
                    <StatusBadge status={task.status} />
                    {task.department && (
                      <span style={{ fontSize: '12px', color: 'var(--color-text-muted)', background: 'var(--color-bg)', padding: '2px 8px', borderRadius: '999px' }}>
                        {task.department.name}
                      </span>
                    )}
                    {task.assignedTo && (
                      <span style={{ fontSize: '12px', color: 'var(--color-text-muted)' }}>→ {task.assignedTo.name}</span>
                    )}
                  </div>
                </div>
                <div style={{ textAlign: 'right', flexShrink: 0 }}>
                  {task.status === 'OVERDUE' ? (
                    <p style={{ fontSize: '13px', color: 'var(--color-danger)', fontWeight: 700 }}>
                      {task.daysOverdue}d overdue
                    </p>
                  ) : (
                    <p style={{ fontSize: '13px', color: 'var(--color-text-muted)' }}>Due {task.deadline}</p>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

const S = {
  title: { fontSize: '22px', fontWeight: 600, color: 'var(--color-primary)', marginBottom: '2px' },
  sub:   { fontSize: '13px', color: 'var(--color-text-muted)' },
};
